module.exports = __webpack_public_path__ + "static/img/28298.3064253.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/28298.jpg
// module id = I02U
// module chunks = 1